export default "__VITE_ASSET__DZZn2yr5__"